import { render, staticRenderFns } from "./63jlzgc.vue?vue&type=template&id=5c66411d&"
import script from "./63jlzgc.vue?vue&type=script&lang=js&"
export * from "./63jlzgc.vue?vue&type=script&lang=js&"
import style0 from "./63jlzgc.vue?vue&type=style&index=0&id=5c66411d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports